<template>
  <div class="wallet">
    <div>
      <van-nav-bar
        @click-left="navTo('/account')"
        fixed
        placeholder
        :title="$t('nav.wallet')"
      >
        <template #left>
          <van-icon color="#000" name="arrow-left" />
        </template>
      </van-nav-bar>
    </div>

    <div class="horizontal-gradient border-radius">
      <div style="width: 100%; height: 138px; color: #fff">
        <van-sticky offset-top="60px">
          <div>{{ $t("account.balance") }}</div>
          <div style="padding: 10px; font-size: 28px">
            ${{ userInfo.showMoney }}
          </div>
          <div style="padding: 10px; font-size: 12px; color: #cbc6c6">
            ID:{{ userInfo.userId }}
          </div>
        </van-sticky>
      </div>
    </div>

    <div class="content-section">
      <van-grid :column-num="3">
        <van-grid-item
          @click="navTo('/recharge')"
          icon="balance-o"
          :text="$t('account.recharge')"
        />
        <van-grid-item
          @click="navTo('/withdraw')"
          icon="cash-on-deliver"
          :text="$t('account.withdraw')"
        />
        <van-grid-item
          @click="navTo('/fundsflow')"
          icon="orders-o"
          :text="$t('account.arecord')"
        />
        <van-grid-item
          @click="navTo('/rechargeRecord')"
          icon="description-o"
          :text="$t('account.rrecord')"
        /><van-grid-item
          @click="navTo('/withdrawRecord')"
          icon="records-o"
          :text="$t('account.wrecord')"
        />
        <!-- <van-grid-item
          icon="balance-o"
          text="文字"
        /> -->
      </van-grid>
    </div>
  </div>
</template>

<script>
export default {
  name: "Recharge",
  components: {},
  data() {
    return {
      username: "",
      password: "",
      active: 1,
      userInfo: {},
    };
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
  },
  methods: {
    onSubmit(values) {
      console.log("submit", values);
    },
    onChange(val) {
      this.active = val;
    },
    navTo(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style>
.horizontal-gradient {
  /* background: linear-gradient(to right, blue, pink); */
  background: #9d8040;
}

.border-radius {
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

.box {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.content-section {
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 10px;
  margin: 0 10px 10px 10px;
}
</style>
